/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";
import constants from "@/constants.js";

export default {
  toggleRightBar({ commit }, value) {
    commit("TOGGLE_RIGHT_BAR", value);
  },
  toggleRightBarPrompt({ commit }, value) {
    commit("TOGGLE_RIGHT_BAR_PROMPT", value);
  },
  togglePreviewMode({ commit }, value) {
    commit("TOGGLE_PREVIEW_MODE", value);
  },
  toggleRouterTransitionStatus({ commit }, value) {
    commit("TOGGLE_ROUTER_TRANSITION_STATUS", value);
  },

  ////////////////////////////////////////
  // Personal Evaluation
  ///////////////////////////////////////

  async saveTypeOfWork({ commit }, personalEvaluationObj) {
    try {
      const _id = personalEvaluationObj._id;
      const typeOfWork = personalEvaluationObj.typeOfWork;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personal-evaluation/${_id}`,
        { typeOfWork }
      );
      commit("SET_PERSONAL_EVALUATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveIndustry({ commit }, personalEvaluationObj) {
    try {
      const _id = personalEvaluationObj._id;
      const industry = personalEvaluationObj.industry;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personal-evaluation/${_id}`,
        { industry }
      );
      commit("SET_PERSONAL_EVALUATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveLocation({ commit }, personalEvaluationObj) {
    try {
      const _id = personalEvaluationObj._id;
      const location = personalEvaluationObj.location;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personal-evaluation/${_id}`,
        { location }
      );
      commit("SET_PERSONAL_EVALUATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePESkipped({ commit }, personalEvaluationObj) {
    try {
      const _id = personalEvaluationObj._id;
      const skipped = personalEvaluationObj.skipped;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personal-evaluation/${_id}`,
        { skipped }
      );
      commit("SET_PERSONAL_EVALUATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePESubmitted({ commit }, personalEvaluationObj) {
    try {
      const _id = personalEvaluationObj._id;
      const submitted = personalEvaluationObj.submitted;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personal-evaluation/${_id}`,
        { submitted }
      );
      commit("SET_PERSONAL_EVALUATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  // Students
  ///////////////////////////////////////

  /*async fetchStudent({commit}, userId) {
    try {
      const resObj = await axios.get(`${constants.apiHost}/students`, {userId});
      commit('SET_STUDENT_DATA', resObj.data.data[0]);
      return resObj;
    } catch (error) {
      throw error;
    }
  },*/

  ////////////////////////////////////////
  // Career History
  ///////////////////////////////////////

  async createCareerHistory({ commit }, whObj) {
    try {
      const userId = whObj.userId;
      const sortId = whObj.sortId;
      const resObj = await axios.post(`${constants.apiHost}/career-history`, {
        userId,
        sortId,
      });
      commit("SET_CAREER_HISTORY_ID", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async deleteCareerHistory({ commit }, careerHistoryId) {
    try {
      const resObj = await axios.delete(
        `${constants.apiHost}/career-history/${careerHistoryId}`
      );
      commit("DELETE_CAREER_HISTORY", careerHistoryId);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateCareerHistoryOrder({ commit }, orderObj) {
    try {
      const _id = orderObj._id;
      const sortId = orderObj.sortId;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { sortId }
      );
      // commit('SET_CAREER_HISTORY_ID', resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveCompany({ commit }, companyObj) {
    try {
      const _id = companyObj._id;
      const company = companyObj.company;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { company }
      );
      commit("SET_COMPANY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveTitle({ commit }, titleObj) {
    try {
      const _id = titleObj._id;
      const title = titleObj.title;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { title }
      );
      commit("SET_TITLE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveStartDate({ commit }, startDateObj) {
    try {
      const _id = startDateObj._id;
      const startDate = startDateObj.startDate;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { startDate }
      );
      // console.log(resObj.data);
      commit("SET_START_DATE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEndDate({ commit }, endDateObj) {
    try {
      const _id = endDateObj._id;
      const endDate = endDateObj.endDate;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { endDate }
      );
      commit("SET_END_DATE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveCurrentlyActive({ commit }, saveCurrentlyActiveObj) {
    try {
      const _id = saveCurrentlyActiveObj._id;
      const currentlyActive = saveCurrentlyActiveObj.currentlyActive;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { currentlyActive }
      );
      commit("SET_CURRENTLY_ACTIVE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveDescription({ commit }, descriptionObj) {
    try {
      const _id = descriptionObj._id;
      const description = descriptionObj.description;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { description }
      );
      commit("SET_DESCRIPTION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveCountry({ commit }, countryObj) {
    try {
      const _id = countryObj ? countryObj._id : "";
      const country = countryObj ? countryObj.country : "";
      // const collectionName = companyObj.collectionName;
      if(_id && country) {
        const resObj = await axios.patch(
          `${constants.apiHost}/career-history/${_id}`,
          { country }
        );
        commit("SET_COUNTRY", resObj.data);
        return resObj;
      }
      return {};
    } catch (error) {
      throw error;
    }
  },
  async getCountry({ commit }, userId) {
    try {
      // const query =  {userId: userId}
      console.log("query", userId);
      const resObj = await axios.get(
        `${constants.apiHost}/career-history/${userId}`
      );
      console.log("data", resObj.data);
      if(resObj.data.data) {
        commit("SET_COUNTRY", resObj.data.data);
        return resObj;
      }
      return {};
    } catch (error) {
      throw error;
    }
  },
  async saveCity({ commit }, cityObj) {
    try {
      const _id = cityObj._id;
      const city = cityObj.city;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { city }
      );
      commit("SET_CITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePromotion({ commit }, promotionObj) {
    try {
      const _id = promotionObj._id;
      const promotions = promotionObj.promotions;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/career-history/${_id}`,
        { promotions }
      );
      commit("SET_PROMOTIONS", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  // Educational Qualification
  ///////////////////////////////////////

  async createEducationalQualification({ commit }, whObj) {
    try {
      const userId = whObj.userId;
      const sortId = whObj.sortId;
      const resObj = await axios.post(
        `${constants.apiHost}/educational-qualifications`,
        { userId, sortId }
      );
      commit("SET_EDUCATIONAL_QUALIFICATIONS_ID", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async deleteEducationalQualification({ commit }, careerHistoryId) {
    try {
      const resObj = await axios.delete(
        `${constants.apiHost}/educational-qualifications/${careerHistoryId}`
      );
      commit("DELETE_EDUCATIONAL_QUALIFICATION", careerHistoryId);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateEducationalQualificationsOrder({ commit }, orderObj) {
    try {
      const _id = orderObj._id;
      const sortId = orderObj.sortId;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { sortId }
      );
      // commit('SET_EDUCATIONAL_QUALIFICATIONS_ID', resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQDegreeCertification({ commit }, degreeCertificationObj) {
    try {
      const _id = degreeCertificationObj._id;
      const degreeCertification = degreeCertificationObj.degreeCertification;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { degreeCertification }
      );
      commit("SET_EQ_DEGREE_CERTIFICATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQOrganization({ commit }, organizationObj) {
    try {
      const _id = organizationObj._id;
      const organization = organizationObj.organization;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { organization }
      );
      commit("SET_EQ_ORGANIZATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQGrade({ commit }, gradeObj) {
    try {
      const _id = gradeObj._id;
      const grade = gradeObj.grade;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { grade }
      );
      commit("SET_EQ_GRADE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQStartDate({ commit }, startDateObj) {
    try {
      const _id = startDateObj._id;
      const startDate = startDateObj.startDate;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { startDate }
      );
      // console.log(resObj.data);
      commit("SET_EQ_START_DATE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQEndDate({ commit }, endDateObj) {
    try {
      const _id = endDateObj._id;
      const endDate = endDateObj.endDate;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { endDate }
      );
      commit("SET_EQ_END_DATE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQCurrentlyActive({ commit }, saveCurrentlyActiveObj) {
    try {
      const _id = saveCurrentlyActiveObj._id;
      const currentlyActive = saveCurrentlyActiveObj.currentlyActive;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { currentlyActive }
      );
      commit("SET_EQ_CURRENTLY_ACTIVE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQDescription({ commit }, descriptionObj) {
    try {
      const _id = descriptionObj._id;
      const description = descriptionObj.description;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { description }
      );
      commit("SET_EQ_DESCRIPTION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQCountry({ commit }, countryObj) {
    try {
      const _id = countryObj._id;
      const country = countryObj.country;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { country }
      );
      commit("SET_EQ_COUNTRY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveEQCity({ commit }, cityObj) {
    try {
      const _id = cityObj._id;
      const city = cityObj.city;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/educational-qualifications/${_id}`,
        { city }
      );
      commit("SET_EQ_CITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  // Projects
  ///////////////////////////////////////

  async createProject({ commit }, whObj) {
    try {
      const userId = whObj.userId;
      const sortId = whObj.sortId;
      const resObj = await axios.post(`${constants.apiHost}/projects`, {
        userId,
        sortId,
      });
      commit("SET_PROJECT_ID", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async deleteProject({ commit }, projectId) {
    try {
      const resObj = await axios.delete(
        `${constants.apiHost}/projects/${projectId}`
      );
      commit("DELETE_PROJECT", projectId);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateProjectsOrder({ commit }, orderObj) {
    try {
      const _id = orderObj._id;
      const sortId = orderObj.sortId;
      const resObj = await axios.patch(`${constants.apiHost}/projects/${_id}`, {
        sortId,
      });
      // commit('SET_CAREER_HISTORY_ID', resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePROrganization({ commit }, organizationObj) {
    try {
      const _id = organizationObj._id;
      const organization = organizationObj.organization;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/projects/${_id}`, {
        organization,
      });
      commit("SET_PR_ORGANIZATION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePRTitle({ commit }, titleObj) {
    try {
      const _id = titleObj._id;
      const title = titleObj.title;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/projects/${_id}`, {
        title,
      });
      commit("SET_PR_TITLE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async savePRDescription({ commit }, descriptionObj) {
    try {
      const _id = descriptionObj._id;
      const description = descriptionObj.description;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/projects/${_id}`, {
        description,
      });
      commit("SET_PR_DESCRIPTION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updateProjectPicture({ commit }, { ppObj, projectId }) {
    try {
      // console.log(ppObj);
      const resObj = await axios.patch(
        `${constants.apiHost}/projects/${projectId}`,
        ppObj
      );
      commit("SET_PR_PROJECT_PICTURE", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  /// Skills
  ////////////////////////////////////////

  async saveProfession({ commit }, professionObj) {
    try {
      const _id = professionObj._id;
      const profession = professionObj.profession;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/users/${_id}`, {
        profession,
      });
      commit("SET_SK_PROFESSION", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  async saveSkills({ commit }, extraCurricularObj) {
    try {
      const _id = extraCurricularObj._id;
      const skills = extraCurricularObj.skills;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/extra-curricular/${_id}`,
        { skills }
      );
      commit("SET_EXTRA_CURRICULAR", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveLanguages({ commit }, extraCurricularObj) {
    try {
      const _id = extraCurricularObj._id;
      const languages = extraCurricularObj.languages;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/extra-curricular/${_id}`,
        { languages }
      );
      commit("SET_EXTRA_CURRICULAR", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async saveHobbies({ commit }, extraCurricularObj) {
    try {
      const _id = extraCurricularObj._id;
      const hobbies = extraCurricularObj.hobbies;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/extra-curricular/${_id}`,
        { hobbies }
      );
      commit("SET_EXTRA_CURRICULAR", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ////////////////////////////////////////
  /// Personality
  ////////////////////////////////////////

  async savePersonalityTraits({ commit }, personalityObj) {
    try {
      // // console.log(personalityObj);
      const _id = personalityObj._id;
      const personalityTraits = personalityObj.personalityTraits;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { personalityTraits }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  // For Dpd Belux
  async savePersonalityTraitsDpdBelux({ commit }, personalityObj) {
    try {
      // // console.log(personalityObj);
      const _id = personalityObj._id;
      const personalityTraitsDpdBelux =
        personalityObj.personalityTraitsDpdBelux;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { personalityTraitsDpdBelux }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  // For Dpd Belux
  async savePersonalityTraitsGala({commit}, personalityObj) {
    try {
      // // console.log(personalityObj);
      const _id = personalityObj._id;
      const personalityTraitsGala = personalityObj.personalityTraitsGala;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(`${constants.apiHost}/personality/${_id}`, {personalityTraitsGala});
      commit('SET_PERSONALITY', resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  async saveBroadcastPersonality({commit}, personalityObj) {
    try {
      const _id = personalityObj._id;
      const broadcastPersonality = personalityObj.broadcastPersonality;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { broadcastPersonality }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  // For DPD Belux
  async saveBroadcastPersonalityDpdBelux({ commit }, personalityObj) {
    try {
      const _id = personalityObj._id;
      const broadcastPersonalityDpdBelux =
        personalityObj.broadcastPersonalityDpdBelux;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { broadcastPersonalityDpdBelux }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  // For DPD Belux
  async saveBroadcastPersonalityGala({ commit }, personalityObj) {
    try {
      const _id = personalityObj._id;
      const broadcastPersonalityGala =
        personalityObj.broadcastPersonalityGala;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { broadcastPersonalityGala }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  async savePersonalityStatements({ commit }, personalityObj) {
    try {
      const _id = personalityObj._id;
      const personalityStatements = personalityObj.personalityStatements;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { personalityStatements }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  // For DPD Belux
  async savePersonalityStatementsDpdBelux({ commit }, personalityObj) {
    try {
      const _id = personalityObj._id;
      const personalityStatementsDpdBelux =
        personalityObj.personalityStatementsDpdBelux;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { personalityStatementsDpdBelux }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  // For Gala
  async savePersonalityStatementsGala({ commit }, personalityObj) {
    try {
      const _id = personalityObj._id;
      const personalityStatementsGala =
        personalityObj.personalityStatementsGala;
      // const collectionName = companyObj.collectionName;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        { personalityStatementsGala }
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },

  ///////////////////
  // Generate Resume PDF
  //////////////////

  async generateResumePDF({ commit }, resumeObj) {
    try {
      // console.log(resumeObj);
      const resObj = await axios.post(
        `${constants.apiHost}/generate-resume`,
        resumeObj
      );
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async updatePersonality({ commit }, data) {
    try {
      // console.log('data',data);
      const _id = data._id;
      const resObj = await axios.patch(
        `${constants.apiHost}/personality/${_id}`,
        data
      );
      commit("SET_PERSONALITY", resObj.data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async tokenGenerate({ commit }, payload) {
    try {
      const resObj = await axios.post(
        `${constants.apiHost}/tokenGenerate`,
        payload
      );
      commit("ADD_TOKEN_STATUS", resObj.data);
      // console.log('data',data);
      return resObj;
    } catch (error) {
      throw error;
    }
  },
  async deleteSession({ commit }, userId) {
    try {
      await axios.delete(`${constants.apiHost}/personality/${userId}`);
    } catch (err) {
      throw err;
    }
  },
  async activeApp({ commit }, item) {
    try {
      commit("SET_ACTIVE_APP", item);
    } catch (err) {
      throw err;
    }
  },
};
